import { render, staticRenderFns } from "./TextEditorsTiny.vue?vue&type=template&id=00497fb6&scoped=true&"
import script from "./TextEditorsTiny.vue?vue&type=script&lang=js&"
export * from "./TextEditorsTiny.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorsTiny.vue?vue&type=style&index=0&id=00497fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00497fb6",
  null
  
)

export default component.exports